export default {
  // TODO 有关eCourier的内容 需要改成对应的日本物流
  modalTitle: '创建eCourier物流单',
  content1: '收货人姓名',
  content2: '收货人电话',
  content3: '省',
  content4: '市',
  content5: '区域',
  content6: '收货地址',
  content7: 'eCourier包裹号',
  content8: '包裹金额',
  content9: '支付方式',
  content10: '商品ID',
  content11: '备注',
  content12: '快递单号',
  content13: '快递单创建失败',
  content14: '确认手工提交',
  placeholder1: '如果手工提交请输入eCourier单号',
  eCourierCode1: '待创建',
  buttonContent1: '提交',
  buttonContent2: '加载中...',
  warning1: '请输入eCourier单号',
  warning2: '此信息不完整',
  warning3: '处理中，请稍后查看',
  open1: 'eCourier运单创建失败',
  cod: '货到付款'
}
